import { QRCode } from "react-qrcode-logo";

/**
 * Brand QR rendering (brief §6): rounded modules on white — always white behind
 * QRs in both themes. Contact QRs get the three finder eyes in Flare; order QRs
 * stay all-ink (receipt ticket).
 */
export function StyledQr({
  value,
  size = 192,
  eyes = "ink",
}: {
  value: string;
  size?: number;
  eyes?: "primary" | "ink";
}) {
  const ink = "#101120";
  return (
    <div data-testid="ec-qr" className="rounded-lg bg-white p-2 leading-none">
      <QRCode
        value={value}
        size={size}
        quietZone={4}
        bgColor="#ffffff"
        fgColor={ink}
        qrStyle="dots"
        eyeRadius={8}
        eyeColor={eyes === "primary" ? "#b0135f" : ink}
        ecLevel="M"
      />
    </div>
  );
}
